import styled from 'styled-components';
import { SuccessIcon } from 'foundations-assets';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import TaskHeaderState from '../TaskHeaderState';
import HelpWidgetButton from '../button/HelpWidgetButton';
import TaskActionButton from '../button/TaskActionButton';
import { TASK_FADE_DURATION_MS } from '../../../constants/task';
import { fadeIn } from '../../../utils/keyFrames';
import { useTaskApi } from '../../../hooks/task';
import { FEATURE_SWITCH_APPS, FeatureSwitch } from '../../FeatureSwitch';
import TaskAssignmentLinks from './TaskAssignmentLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/* @bend-expect no-styled-foundations-components */
const CompletedTaskCard = styled(CardWrapper).withConfig({
  displayName: "CompletedTask__CompletedTaskCard",
  componentId: "ypqnzq-0"
})(["animation:", " ", "ms ease-in-out;"], fadeIn, TASK_FADE_DURATION_MS);
const CompletedTask = ({
  expanded,
  onExpandedChange,
  task
}) => {
  const isExpandable = Boolean(task.description || task.helpWidgetLink || task.repeatable);
  const {
    checkAndCompleteTask,
    completeTask
  } = useTaskApi();
  return /*#__PURE__*/_jsxs(CompletedTaskCard, {
    compact: true,
    "data-onboarding": `task:${task.key}`,
    "data-task-status": "completed",
    "data-test-id": `task:${task.key}`,
    expandable: isExpandable,
    expanded: expanded,
    marginBlockEnd: "0",
    onExpandedChange: isExpanded => {
      onExpandedChange(isExpanded, 'completed');
    },
    paddingInlineStart: !isExpandable ? '600' : undefined,
    children: [/*#__PURE__*/_jsx(TaskHeaderState, {
      children: /*#__PURE__*/_jsx(SuccessIcon, {
        color: "icon-positive-default",
        size: "400"
      })
    }), /*#__PURE__*/_jsx(CardHeader, {
      "data-test-id": "task-header",
      marginInlineEnd: "500",
      paddingInline: "400",
      title: /*#__PURE__*/_jsx(Text, {
        textDecoration: "line-through",
        typography: "heading-100",
        children: task.name
      }),
      titleSize: "small"
    }), isExpandable && /*#__PURE__*/_jsx(CardSection, {
      "data-test-id": "task-section",
      paddingBlockEnd: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: "column",
        paddingBlockEnd: "500",
        paddingInline: "600",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "span",
          children: [task.description && /*#__PURE__*/_jsxs(_Fragment, {
            children: [typeof task.description === 'string' ? task.description.trim() : task.description, /*#__PURE__*/_jsx(Spacer, {
              display: "inline-block",
              space: "100"
            })]
          }), /*#__PURE__*/_jsx(HelpWidgetButton, {
            task: task
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: "500",
          marginBlockStart: "400",
          children: [task.repeatable && /*#__PURE__*/_jsx(TaskActionButton, {
            checkAndCompleteTask: checkAndCompleteTask,
            completeTask: completeTask,
            task: task,
            use: "tertiary-light"
          }), /*#__PURE__*/_jsx(FeatureSwitch, {
            allowedApps: [FEATURE_SWITCH_APPS.USER_GUIDE],
            skipFeatureLoad: !expanded,
            children: /*#__PURE__*/_jsx(TaskAssignmentLinks, {
              hideIfNoAssignment: true,
              task: task
            })
          })]
        })]
      })
    })]
  });
};
export default CompletedTask;